var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBordered({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7502 7.32715C11.7502 6.91293 11.4144 6.57715 11.0002 6.57715C10.5859 6.57715 10.2502 6.91293 10.2502 7.32715V10.2404H7.3335C6.91928 10.2404 6.5835 10.5762 6.5835 10.9904C6.5835 11.4046 6.91928 11.7404 7.3335 11.7404H10.2502V14.6535C10.2502 15.0677 10.5859 15.4035 11.0002 15.4035C11.4144 15.4035 11.7502 15.0677 11.7502 14.6535V11.7404H14.6668C15.081 11.7404 15.4168 11.4046 15.4168 10.9904C15.4168 10.5762 15.081 10.2404 14.6668 10.2404H11.7502V7.32715Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6857 1H6.31429C3.04762 1 1 3.31208 1 6.58516V15.4148C1 18.6879 3.0381 21 6.31429 21H15.6857C18.9619 21 21 18.6879 21 15.4148V6.58516C21 3.31208 18.9619 1 15.6857 1Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBordered);
export default __webpack_public_path__ + "static/media/plus_bordered.ef71b7e4508993a5f5f3e647b5cfa6b0.svg";
export { ForwardRef as ReactComponent };